import { createContext as f, createElement as s, useContext as w, useRef as c, useEffect as v } from "react";
const a = f(null);
function E({ client: e, children: t }) {
  return s(a.Provider, { value: e }, t);
}
function h() {
  const e = w(a);
  if (!e)
    throw new Error("[analytics] useAnalytics must be used within an <AnalyticsProvider>.");
  return e;
}
const y = 3e4, m = 1e3, l = ["mousemove", "mousedown", "keydown", "scroll", "touchstart"];
function I(e) {
  const t = c(0), n = c(0), r = c(!1);
  v(() => {
    n.current = Date.now();
    const u = () => {
      n.current = Date.now();
    };
    l.forEach((i) => window.addEventListener(i, u, { passive: !0 }));
    const d = setInterval(() => {
      Date.now() - n.current < y && (t.current += 1);
    }, m), o = () => {
      r.current || (r.current = !0, e.track("page.time-on-page", {
        duration_seconds: t.current
      }));
    };
    return window.addEventListener("beforeunload", o), () => {
      clearInterval(d), l.forEach((i) => window.removeEventListener(i, u)), window.removeEventListener("beforeunload", o), o();
    };
  }, [e]);
}
function C(e) {
  return function(n) {
    return s(a.Consumer, {
      children: (r) => {
        if (!r)
          throw new Error("[analytics] withAnalytics must be used within an <AnalyticsProvider>.");
        return s(e, { ...n, analytics: r });
      }
    });
  };
}
export {
  E as AnalyticsProvider,
  h as useAnalytics,
  I as useTimeOnPage,
  C as withAnalytics
};



// WEBPACK FOOTER //
// ./~/@3plearning/mx-teacher-analytics/dist/react.js